import { GlCollapsibleListbox } from '../../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
import { __ } from '~/locale';
import { statusDropdownOptions } from '../../constants';
export default {
    name: 'StatusDropdown',
    components: {
        GlCollapsibleListbox
    },
    data () {
        return {
            selectedValue: undefined
        };
    },
    computed: {
        dropdownText () {
            const selected = this.$options.statusDropdownOptions.find((option)=>option.value === this.selectedValue);
            return selected?.text || this.$options.i18n.defaultDropdownText;
        }
    },
    methods: {
        handleReset () {
            this.selectedValue = undefined;
        }
    },
    i18n: {
        dropdownTitle: __('Change state'),
        defaultDropdownText: __('Select state'),
        resetText: __('Reset')
    },
    statusDropdownOptions
};
